<template>
  <section>
    <strong
      v-if="demand.description.type !== DEMAND_TYPES.GOAL"
      data-testid="demand-code"
      class="demand-widget-label__code"
    >
      {{ code }}
    </strong>
    <WTitle class="demand-widget-label__name" size="xsmall">
      {{ description }}
    </WTitle>
    <WTag
      class="demand-widget-label__occurrence"
      :color="isFirstOccurrence ? 'blue' : 'gray'"
      :label="occurrenceLabel"
      size="small"
    />
  </section>
</template>
<script>
import { WTag, WTitle } from '@alice-health/wonderland-vue'

import { DEMAND_TYPES } from '@/models/demands'
import { getDemandCode, getDemandDescription } from '@/utils/demands'

export default {
  components: { WTitle, WTag },
  props: {
    demand: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      DEMAND_TYPES
    }
  },
  computed: {
    code() {
      return getDemandCode(this.demand)
    },
    description() {
      return getDemandDescription(this.demand)
    },
    isFirstOccurrence() {
      return !this.demand.caseId
    },
    occurrenceLabel() {
      return this.isFirstOccurrence
        ? 'Primeira ocorrência na lista de demandas'
        : 'Existe ocorrência na lista de demandas'
    }
  }
}
</script>

<style lang="scss" scoped>
.demand-widget-label {
  &__code {
    color: var(--gl-color-shades-gray-70);
    font-size: var(--gl-font-size-xxxs);
    margin-top: var(--gl-spacing-04);
  }

  &__name {
    color: var(--gl-color-shades-gray-100);
    font-weight: var(--gl-font-weight-regular);
    font-size: var(--gl-font-size-xs);
  }

  &__occurrence {
    margin-top: var(--gl-spacing-03);
  }
}
</style>
